export default __webpack_public_path__ + "static/media/Upload.7e664bc3.svg";